import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Employee, LeaveApplication} from "../interface/employee";
import {first, take} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {FilterService} from "./filter.service";
import {DOCUMENT} from "@angular/common";
import {CountedAndPaginated} from "../interface/response/counted-and-paginated";
import {PartnerFacility} from "../interface/partner-facility";
import {Uuid} from "../interface/response/uuid";

@Injectable({
  providedIn: 'root'
})
export class LeaveApplicationService {

  private readonly leaveApplicationListSubject: ReplaySubject<CountedAndPaginated<LeaveApplication>>
    = new ReplaySubject<CountedAndPaginated<LeaveApplication>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,

  ) { }

  public get(leaveApplicationId: string): Observable<LeaveApplication> {
    return this.httpClient.get(`/rest/crm/leave-application/${leaveApplicationId}`)
      .pipe(first()) as Observable<LeaveApplication>;
  }

  statusUpdate(leaveApplicationId: string, status: number, valid = false): Observable<any> {
    return this.httpClient.post(`/rest/crm/leave-application/${leaveApplicationId}/statusUpdate`,
      {
        status: status,
        valid: valid
      })
      .pipe(take(1));
  }

  downloadCertificate(ofwcaMeetingId: string): void {
    this.document.location.href = `/rest/crm/leave-application/${ofwcaMeetingId}/document`;
  }

  public getleaveApplicationListSubject(): ReplaySubject<CountedAndPaginated<LeaveApplication>> {
    return this.leaveApplicationListSubject;
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/leave-application?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<LeaveApplication>) => {
        this.leaveApplicationListSubject.next(result);
      });
  }
  public downloadDocument(leaveApplicationId: string): void {
    this.document.location.href = `/rest/crm/leave-application/${leaveApplicationId}/downloadFile`;
  }

  public sendFile(formData: object,  employeeId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/leave-application/${employeeId}/file`, formData)
      .pipe(
        take(1)
      );
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/leave-application/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
